// todo(egor): move to `core-js`

/**
 * extract file name from multipart response
 */
export function extractFileName(response) {
  let headerLine = response.headers['content-disposition'];
  let result = null;
  if (headerLine.indexOf('*=utf-8') > -1) {
    let startFileNameIndex = headerLine.lastIndexOf("*=utf-8''") + "*=utf-8''".length;
    let resultEncoded = headerLine.substring(startFileNameIndex, headerLine.length);
    result = decodeURIComponent(resultEncoded)
  } else {
    let startFileNameIndex = headerLine.lastIndexOf('=') + 1;
    result = headerLine.substring(startFileNameIndex, headerLine.length)
  }

  result = result.replace(/"/g, ""); // fix bug with head&tail `"`

  return result;
}



// WEBPACK FOOTER //
// ./src/helpers/file.js